export default {
  data() {
    return {
      modules: ['search'],
    };
  },
};
